import React from 'react'
import DashedLink from '../DashedLink'
import './index.css'

const DashedLinkAbort = (props) => {
  //Get status from props
  const { status } = props 
  
  const changeStatus = (options) => {
    props.onSelectStatus(...options, status)
  }
  return (
    <DashedLink
      name={'Abort'}
      onClick={() => changeStatus(props.options)}
      disabled={props.disabled}
    >
      <span>{props.name}</span>
    </DashedLink>
  )
}
export default DashedLinkAbort